// @ts-nocheck
import { COMBINATION_LOCK_LIST_RECEIVED, COMBINATION_LOCK_ITEM_RECEIVED } from '../types';

const initialState = {
    list: [],
    current: null,
};

const combinationLock = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case COMBINATION_LOCK_LIST_RECEIVED: {
            return {
                ...state,
                list: payload,
            };
        }
        case COMBINATION_LOCK_ITEM_RECEIVED: {
            return {
                ...state,
                current: payload,
            };
        }
        default: {
            return state;
        }
    }
};

export default combinationLock;
